import React from 'react';
import Helmet from 'react-helmet';
import { defineMessages, injectIntl } from '@kyruus/intl';

const messages = defineMessages({
  mapsearchpagetitle: {
    id: 'pmc.mapsearch.pagetitle',
    description: 'Page title for map-search',
    defaultMessage: '{searchDescription} - Map - ProviderMatch'
  }
});

function MapSearchMetas({ search, intl }) {
  const getPageTitle = (search) => {
    if (!search.search_description) return null;
    return intl.formatMessage(messages.mapsearchpagetitle, {
      searchDescription: search.search_description
    });
  };
  return <Helmet title={getPageTitle(search)} />;
}

export default injectIntl(MapSearchMetas);
